import type { TokenizationWidgetConfig } from "@blockdaemon/widget-config";
import { createWidgetConfigLoader } from "@blockdaemon/widget-host";
import { CONFIG_WIDGET_TYPE_QUERY_PARAM } from "@blockdaemon/widget-metadata";

// When embedded, the config provider requests a host JWT via postMessage and passes it here.
const loader = createWidgetConfigLoader<TokenizationWidgetConfig>(
  "tokenization",
  `/api/config?${CONFIG_WIDGET_TYPE_QUERY_PARAM}=tokenization`,
);

export const cacheTokenizationConfig = loader.cacheConfig;
export const fetchTokenizationConfig = loader.fetchConfig;
export const useTokenizationConfigQuery = loader.useConfigQuery;
export const invalidateTokenizationConfigQueries = loader.invalidateConfigQueries;
